import React from 'react';
import { SlidersHorizontal, ChevronRight } from 'lucide-react';
const filters = [{
  label: 'Ordenar por',
  subtitle: 'Mejor coincidencia'
}, {
  label: 'Distancia o Envío'
}, {
  label: 'Precio'
}, {
  label: 'Marca y Modelo'
}, {
  label: 'Tipo de Carrocería'
}, {
  label: 'Año'
}, {
  label: 'Kilometraje'
}, {
  label: 'Tipo de Combustible'
}, {
  label: 'Características'
}, {
  label: 'Tamaño del Auto'
}, {
  label: 'Puertas'
}];
export function FilterSidebar() {
  return <aside className="hidden lg:block w-[280px] flex-shrink-0 border-r border-[#D5D5D5] bg-[#F2F2F2] min-h-[calc(100vh-140px)]" data-id="element-264">
      {/* Header */}
      <div className="p-6 flex items-center gap-3 border-b border-[#D5D5D5]" data-id="element-265">
        <SlidersHorizontal className="w-5 h-5 text-[#1C1C1C]" strokeWidth={1.5} data-id="element-266" />
        <h2 className="text-[15px] font-bold text-[#1C1C1C]" data-id="element-267">
          Filtrar y Ordenar
        </h2>
      </div>

      {/* Filter List */}
      <div className="flex flex-col" data-id="element-268">
        {filters.map((filter, index) => <button key={index} className="w-full flex items-center justify-between px-6 py-4 border-b border-[#E0E0E0] hover:bg-[#E8E8E8] transition-colors text-left group" data-id="element-269">
            <div className="flex flex-col" data-id="element-270">
              <span className="text-[15px] text-[#1C1C1C] group-hover:text-[#4A90E2] transition-colors" data-id="element-271">
                {filter.label}
              </span>
              {filter.subtitle && <span className="text-[13px] text-gray-500 mt-0.5" data-id="element-272">
                  {filter.subtitle}
                </span>}
            </div>
            <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-[#4A90E2] transition-colors" strokeWidth={1.5} data-id="element-273" />
          </button>)}
      </div>
    </aside>;
}